import TermsScreen from "./index";

const routes = [
  {
    path: "/privacy",
    component: TermsScreen,
  },
];

export default routes;
